import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import { pathMatcher } from '@/utils/index'
import { getLogo } from '@/api/user'

const whiteList = ['/softwareDownload', '/performance_record', '/rechargeTutorial', '/verifyFairness', '/commisRecord', '/inviteFriends', '/rechargeRecord', '/recharge', '/user', '/rules', '/orderRecord', '/detailView', '/home', '/login', '/registry', '/', '/index', '/category', '/detail/**', '/diamondGoodsList/**'] // 白名单
const telList = ['/groupBag', '/sendBag', '/peopleList', '/compositor', '/talkAdventure', '/wealthRankings']
router.beforeEach(async(to, from, next) => {
  // await getLogo().then(res => {
  //   document.title = res.logoname
  //   var link1 = document.createElement('link')
  //   var meta = document.getElementsByTagName('meta')['apple-mobile-title']
  //   link1.id = 'longlogo'
  //   link1.href = res.logourl
  //   meta.content = res.logoname
  //   var head = document.getElementsByTagName('head')[0]
  //   head.appendChild(link1)
  // })
  // 根据token判断用户是否登录
  const hasToken = getToken()

  if (hasToken) {
    await store.dispatch('user/resetToken', hasToken)
    if (to.path === '/login') {
      // 如果已经登录了，而去的又是login页就重定向到首页
      next({ path: '/' })
    } else {
      const hasUserInfo = store.getters.userInfo.ucode
      if (hasUserInfo) {
        next()
      } else {
        // 如果用户刷新了浏览器，那么需要重新请求基本信息塞到vuex中进行状态管理
        try {
          await store.dispatch('user/getInfo')
          next()
        } catch (error) {
          if (pathMatcher(whiteList, to.path)) {
            next()
          } else {
            next()
            // 清空token重新去登录
            // await store.dispatch('user/resetToken')
            // next(`/login?redirect=${encodeURIComponent(location.href)}`)
          }
        }
      }
    }
  } else {
    next()
    // if (pathMatcher(whiteList, to.path)) {
    //   next()
    // } else {
    //   next()// 该项目无注册登录
    //   // 反之则去登录页面
    //   // next(`/login?redirect=${encodeURIComponent(location.href)}`)
    // }
  }
})

router.afterEach(() => {
  Toast.clear()
})
